const appConfig = require('./app.config.json');

// /* eslint-disable */
const dockerCompose = process.env.WEB_COMPOSE || false;
const webAppDNS = process.env.WEB_BACKEND_DNSNAME || 'http://localhost';

const bookingPort = (dockerCompose) ? '' : ':3000';
const billingPort = (dockerCompose) ? '' : ':3001';

appConfig.api.port = bookingPort;
appConfig.api.billingPort = billingPort;
appConfig.api.url = webAppDNS;



// WEBPACK FOOTER //
// ./config/configuration.js